import { deleteCookie } from '@/shared/utils/cookie';
import { AUTH_COOKIE_KEY, getSessionFromCookie } from '@/shared/utils/session';

import { LEGACY_SESSION_STORAGE_KEY } from './mode';

const REFRESH_SCHEME_V6 = 'v6' as const;

const readStoredRefreshToken = (): string | undefined => {
  const raw = window.localStorage.getItem(LEGACY_SESSION_STORAGE_KEY);

  if (raw === null) {
    return undefined;
  }

  try {
    const parsed: unknown = JSON.parse(raw);

    if (
      parsed !== null &&
      typeof parsed === 'object' &&
      'refreshToken' in parsed &&
      typeof parsed.refreshToken === 'string'
    ) {
      return parsed.refreshToken;
    }
  } catch {
    // A broken record is the same as none: the import just does not run.
  }

  return undefined;
};

/**
 * The legacy (V6) refresh token importLegacySession hands to the mediator. The
 * hand-off cookie from wheely.com wins over a stored pre-migration session:
 * it is the fresher of the two.
 */
export const readLegacySession = async (): Promise<
  { refreshToken: string; scheme: typeof REFRESH_SCHEME_V6 } | undefined
> => {
  const refreshToken = getSessionFromCookie()?.refreshToken ?? readStoredRefreshToken();

  return refreshToken ? { refreshToken, scheme: REFRESH_SCHEME_V6 } : undefined;
};

/**
 * Wipes every legacy copy. The import calls it after a success and after a
 * terminal refusal; from then on the mode detector answers V3 for good.
 */
export const cleanupLegacySession = async (): Promise<void> => {
  window.localStorage.removeItem(LEGACY_SESSION_STORAGE_KEY);
  window.localStorage.removeItem(`${LEGACY_SESSION_STORAGE_KEY}-sync`);
  deleteCookie(AUTH_COOKIE_KEY);
};
